import CardGroups from "./CardGroups";
import Intro from "./Intro";
import SharedHelmet from './Helmet';
const TITLE = 'Quick Calculators';
const DESCRIPTION = "a set of advanced computer tools designed to meet the needs of individuals, engineers, doctors, pharmacists, hospitals, and companies. All calculators have been developed using trusted global sources such as the World Health Organization. These calculators are distinguished by their support for open APIs, allowing developers to easily use them in their software development";
const KEYWORDS = "Age calculator, Age calculator in Gregorian, Age calculator in Hijri, Age difference calculator, Date difference calculator, Body Mass Index calculator, BMI calculator, Calorie calculator, Basal Metabolic Rate calculator, Ideal weight calculator, Body fat calculator, Conversion between nutritional energy units, Pregnancy calculator, Fertility calculator, Birth calculator, Ovulation calculator, Menstrual cycle calculator, Wealth Zakat calculator, Gold Zakat calculator, Silver Zakat calculator, Fruit Zakat calculator, Trade property Zakat calculator, Animal Zakat calculator, Conversion of gold carats to different carats.";
const OG_URL = 'https://do-calculate.com/en';
const IMAGE_URL = 'https://do-calculate.com/logo512.png'
function LandingPage()
{
    return (
        <div>
             <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} IMAGE={IMAGE_URL} />
            <Intro />
            <CardGroups />
        </div>
    )
}
export default LandingPage;